define('display/layers/vector/styles/night',['./definitions'], function(definitions) {
    // For more details of styling see: https://www.mapbox.com/mapbox-gl-style-spec/
    var iconRange = definitions.iconRange,
        roadsWidthStops = definitions.roadsWidthStops,
        padding = definitions.padding,
        labelTextStops = definitions.labelTextStops,
        labelTextHalo = definitions.labelTextHalo,
        nightColorMap = definitions.nightColorMap;

    var fonts = {
        regular: ['FrutigerHelveticaMYingHei-Regular'],
        medium: ['FrutigerHelveticaMYingHei-Medium'],
        bold: ['FrutigerHelveticaMYingHei-Bold'],
        heavy: ['FrutigerHelveticaMYingHei-Heavy']
    };

    var nightBackgroundLayer = {
        'id': 'background',
        'type': 'background',
        'paint': {
            'background-color': nightColorMap.background
        }
    };

    var textOffset = [0, 0.1];

    var nightLanduse = [
        {
            'id': 'National park',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'National park',
            'paint': {
                'fill-color': nightColorMap.nationalPark
            }
        },
        {
            'id': 'Park',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Park',
            'paint': {
                'fill-color': nightColorMap.park
            }
        },
        {
            'id': 'National or state park',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'National or state park',
            'paint': {
                'fill-color': nightColorMap.nationalPark
            }
        },
        {
            'id': 'State or province park',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'State or province park',
            'paint': {
                'fill-color': nightColorMap.statePark
            }
        },
        {
            'id': 'County park',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'County park',
            'paint': {
                'fill-color': nightColorMap.park
            }
        },
        {
            'id': 'Beach or dune',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Beach or dune',
            'paint': {
                'fill-color': nightColorMap.beachDune
            }
        },
        {
            'id': 'Regional park',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Regional park',
            'paint': {
                'fill-color': nightColorMap.regionalPark
            }
        },
        {
            'id': 'Woodland',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Woodland',
            'paint': {
                'fill-color': nightColorMap.woodland
            }
        },
        {
            'id': 'Sand',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Sand',
            'paint': {
                'fill-color': nightColorMap.sand
            }
        },
        {
            'id': 'Moor or heathland',
            'type': 'fill',
            'source': 'vectorTiles',
            'minzoom': 10,
            'source-layer': 'Moor or heathland',
            'paint': {
                'fill-color': nightColorMap.moor
            }
        },
        {
            'id': 'Built-up area',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Built-up area',
            'paint': {
                'fill-color': nightColorMap.builtUpArea
            }
        },
        {
            'id': 'Military',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Military',
            'paint': {
                'fill-color': nightColorMap.military
            }
        },
        {
            'id': 'Town railway ground',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Town railway ground',
            'paint': {
                'fill-color': nightColorMap.blocksRailwayGround
            }
        },
        {
            'id': 'City park',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'City park',
            'paint': {
                'fill-color': nightColorMap.park
            }
        },
        {
            'id': 'Forest',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Forest',
            'paint': {
                'fill-color': nightColorMap.forest
            }
        },
        {
            'id': 'Cemetery',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Cemetery',
            'paint': {
                'fill-color': nightColorMap.cemetery
            }
        },
        {
            'id': 'Industrial area',
            'type': 'fill',
            'source': 'vectorTiles',
            'maxzoom': 16,
            'source-layer': 'Industrial area',
            'paint': {
                'fill-color': nightColorMap.industrial
            }
        },
        {
            'id': 'Industrial harbor area',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Industrial harbor area',
            'paint': {
                'fill-color': nightColorMap.industrialHarbor
            }
        },
        {
            'id': 'Hospital',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Hospital',
            'paint': {
                'fill-color': nightColorMap.hospital
            }
        },
        {
            'id': 'Town greens',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Town greens',
            'paint': {
                'fill-color': nightColorMap.blocksGreen
            }
        },
        {
            'id': 'Golf',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Golf',
            'paint': {
                'fill-color': nightColorMap.golf
            }
        },
        {
            'id': 'Shopping',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Shopping',
            'paint': {
                'fill-color': nightColorMap.shop
            }
        },
        {
            'id': 'Airport',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Airport',
            'paint': {
                'fill-color': nightColorMap.airport
            }
        },
        {
            'id': 'Runway',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Runway',
            'paint': {
                'fill-color': nightColorMap.runway
            }
        },
        {
            'id': 'Town paved area',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Town paved area',
            'paint': {
                'fill-color': nightColorMap.blocksPaved
            }
        },
        {
            'id': 'Town garden path',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Town garden path',
            'paint': {
                'fill-color': nightColorMap.blocksGardenPath
            }
        },
        {
            'id': 'School building 0',
            'type': 'fill',
            'source': 'vectorTiles',
            'maxzoom': 16,
            'source-layer': 'School building',
            'paint': {
                'fill-color': nightColorMap.school
            }
        },
        {
            'id': 'Town school ground 0',
            'type': 'fill',
            'source': 'vectorTiles',
            'minzoom': 0,
            'maxzoom': 16,
            'source-layer': 'Town school ground',
            'paint': {
                'fill-color': nightColorMap.blocksSchoolGround
            }
        },
        {
            'id': 'University',
            'type': 'fill',
            'source': 'vectorTiles',
            'minzoom': 14,
            'source-layer': 'University',
            'paint': {
                'fill-color': nightColorMap.university
            }
        },
        {
            'id': 'School',
            'type': 'fill',
            'source': 'vectorTiles',
            'maxzoom': 16,
            'source-layer': 'School',
            'paint': {
                'fill-color': nightColorMap.school
            }
        },
        {
            'id': 'Institution',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Institution',
            'paint': {
                'fill-color': nightColorMap.institution
            }
        },
        {
            'id': 'Government Administration Office',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Government Administration Office',
            'paint': {
                'fill-color': nightColorMap.buildingGovernment
            }
        },
        {
            'id': 'Other building',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Other building',
            'paint': {
                'fill-color': nightColorMap.buildingOther
            }
        },
        {
            'id': 'Pedestrian Deck',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Pedestrian Deck',
            'paint': {
                'fill-color': nightColorMap.blocksPedestrianDeck
            }
        },
        {
            'id': 'Other town block',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Other town block',
            'paint': {
                'fill-color': nightColorMap.buildingOther
            }
        },
        {
            'id': 'Pool',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Pool',
            'paint': {
                'fill-color': nightColorMap.pool
            }
        },
        {
            'id': 'Zoo',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Zoo',
            'paint': {
                'fill-color': nightColorMap.zoo
            }
        },
        {
            'id': 'Stadium',
            'type': 'fill',
            'source': 'vectorTiles',
            'minzoom': 14,
            'source-layer': 'Stadium',
            'paint': {
                'fill-color': nightColorMap.stadium
            }
        },
        {
            'id': 'Sports hall',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Sports hall',
            'paint': {
                'fill-color': nightColorMap.sportsHall
            }
        },
        {
            'id': 'Amusement park',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Amusement park',
            'paint': {
                'fill-color': nightColorMap.amusement
            }
        },
        {
            'id': 'Town grass',
            'type': 'fill',
            'source': 'vectorTiles',
            'minzoom': 14,
            'source-layer': 'Town grass',
            'paint': {
                'fill-color': nightColorMap.blocksGrass
            }
        },
        {
            'id': 'Town swimming pool',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Town swimming pool',
            'paint': {
                'fill-color': nightColorMap.blocksSwimmingPool
            }
        },
        {
            'id': 'Town walkway',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Town walkway',
            'paint': {
                'fill-color': nightColorMap.blocksWalkway
            }
        },
        {
            'id': 'Town factory ground 0',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Town factory ground',
            'minzoom': 0,
            'maxzoom': 16,
            'paint': {
                'fill-color': nightColorMap.industrial
            }
        },
        {
            'id': 'Town water body',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Town water body',
            'paint': {
                'fill-color': nightColorMap.blocksWater
            }
        },
        {
            'id': 'Factory building',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Factory building',
            'paint': {
                'fill-color': nightColorMap.buildingFactory
            }
        },
        {
            'id': 'Place of worship',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Place of worship',
            'paint': {
                'fill-color': nightColorMap.buildingWorship
            }
        },
        {
            'id': 'Hospital building',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Hospital building',
            'paint': {
                'fill-color': nightColorMap.buildingHospital
            }
        },
        {
            'id': 'School building 16',
            'type': 'fill',
            'source': 'vectorTiles',
            'minzoom': 16,
            'source-layer': 'School building',
            'paint': {
                'fill-color': nightColorMap.school
            }
        },
        {
            'id': 'Hotel building',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Hotel building',
            'paint': {
                'fill-color': nightColorMap.buildingHotel
            }
        },
        {
            'id': 'Cultural Facility',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Cultural Facility',
            'paint': {
                'fill-color': nightColorMap.buildingCulture
            }
        },
        {
            'id': 'Railway Station',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Railway Station',
            'paint': {
                'fill-color': nightColorMap.buildingRailwayStat
            }
        },
        {
            'id': 'Parking area',
            'type': 'fill',
            'source': 'vectorTiles',
            'minzoom': 15,
            'source-layer': 'Parking area',
            'paint': {
                'fill-color': nightColorMap.parking
            }
        },
        {
            'id': 'Subway Station',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Subway Station',
            'paint': {
                'fill-color': nightColorMap.buildingSubwayStat
            }
        },
        {
            'id': 'Town hospital ground',
            'type': 'fill',
            'source': 'vectorTiles',
            'maxzoom': 16,
            'source-layer': 'Town hospital ground',
            'paint': {
                'fill-color': nightColorMap.blocksHospitalGround
            }
        },
        {
            'id': 'Town shore',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Town shore',
            'paint': {
                'fill-color': nightColorMap.sand
            }
        },
        {
            'id': 'Meridian',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Meridian',
            'paint': {
                'fill-color': nightColorMap.meridian
            }
        },
        {
            'id': 'Sidewalk',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Sidewalk',
            'paint': {
                'fill-color': nightColorMap.sidewalk
            }
        },
        {
            'id': 'Breakwater',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Breakwater',
            'paint': {
                'fill-color': nightColorMap.breakwater
            }
        }
    ];

    var nightWater = [
        {
            'id': 'Other water',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Other water',
            'paint': {
                'fill-color': nightColorMap.water
            }
        },
        {
            'id': 'Intermittent water',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Intermittent water',
            'paint': {
                'fill-color': nightColorMap.wadi
            }
        },
        {
            'id': 'Lake',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Lake',
            'paint': {
                'fill-color': nightColorMap.lake
            }
        },
        {
            'id': 'Ocean or sea',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Ocean or sea',
            'paint': {
                'fill-color': nightColorMap.oceanSea
            }
        },
        {
            'id': 'Ocean',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Ocean',
            'paint': {
                'fill-color': nightColorMap.oceanSea
            }
        },
        {
            'id': 'Sea',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'Sea',
            'paint': {
                'fill-color': nightColorMap.oceanSea
            }
        },
        {
            'id': 'River',
            'type': 'fill',
            'source': 'vectorTiles',
            'source-layer': 'River',
            'paint': {
                'fill-color': nightColorMap.water
            }
        }
    ];
    //* ----- ROADS ----- */
    var nightRoads = [
        {
            'id': 'Railway outline',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Railway',
            'paint': {
                'line-color': nightColorMap.railWayStrokeSquare,
                'line-width': {
                    'stops': roadsWidthStops.railOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Railway',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Railway',
            'paint': {
                'line-color': nightColorMap.railWayStrokeRound,
                'line-width': {
                    'stops': roadsWidthStops.rail
                },
                'line-dasharray': [7.0, 7.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll minor local road 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll minor local road 7t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road',
            'minzoom': 7,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.localRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road 7t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road',
            'minzoom': 7,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.localRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road 7t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road',
            'minzoom': 7,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road 7t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'minzoom': 7,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 7t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 7,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 7t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 7,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 7t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 7,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.motorwayToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway 7t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway',
            'minzoom': 7,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.motorwayToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        { // Tunnels
            'id': 'Toll minor local road tunnel 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road tunnel',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll minor local road tunnel 0t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road tunnel',
            'minzoom': 0,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road tunnel 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road tunnel',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.localRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road tunnel 0t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road tunnel',
            'minzoom': 0,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.localRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road tunnel 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road tunnel',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road tunnel 0t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road tunnel',
            'minzoom': 0,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road tunnel 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road tunnel 0t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'minzoom': 0,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 0t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 0,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 0t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 0,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'minzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 0t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway tunnel 14t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway tunnel',
            'minzoom': 14,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.tollRoads1518,
                'line-width': {
                    'stops': roadsWidthStops.motorwayToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway tunnel 0t',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway tunnel',
            'minzoom': 0,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.tollRoads714,
                'line-width': {
                    'stops': roadsWidthStops.motorwayToll
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Non public road outline',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Non public road',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.nonPublicRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Pedestrian road outline',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Pedestrian road',
            'minzoom': 16,
            'paint': {
                'line-color': nightColorMap.pedestrianRoad1617Outl,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Walkway road outline',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Walkway road',
            'minzoom': 16,
            'paint': {
                'line-color': nightColorMap.walkwayRoad1617Outl,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Parking road 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Parking road',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Parking road 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Parking road',
            'minzoom': 11,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1114Outl,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        { // Toll tunnels
            'id': 'Toll minor local road tunnel 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road tunnel',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll minor local road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road tunnel',
            'minzoom': 0,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1114Outl,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road tunnel 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road tunnel',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.localRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.localRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road tunnel',
            'minzoom': 0,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.localRoad1114Outl,
                'line-width': {
                    'stops': roadsWidthStops.localRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road tunnel 16o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road tunnel',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad1617Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road tunnel',
            'minzoom': 0,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad1215Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road tunnel 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.connectingRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road tunnel 14o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.connectingRoad14Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road tunnel 12o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'minzoom': 12,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.connectingRoad1213Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road tunnel 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.connectingRoad11Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'minzoom': 0,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.connectingRoad10Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 14o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.secondaryRoad14Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 12o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 12,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1213Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.secondaryRoad11Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 10o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 10,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.secondaryRoad10Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 0,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.secondaryRoad9Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 17o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 17,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorRoad17Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 16o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 16,
            'maxzoom': 17,
            'paint': {
                'line-color': nightColorMap.majorRoad16Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorRoad15Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 10o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 10,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.majorRoad1014Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 0,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.majorRoad89Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 16o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'minzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad1617Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 14o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.internationalRoad1415Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'minzoom': 11,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.internationalRoad1113Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.internationalRoad710Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway tunnel Ao',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway tunnel',
            'paint': {
                'line-color': nightColorMap.motorwayOutl,
                'line-width': {
                    'stops': roadsWidthStops.motorwayOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        { // Toll roads oulines
            'id': 'Toll minor local road 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll minor local road 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road',
            'minzoom': 11,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1114Outl,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.localRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.localRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road',
            'minzoom': 11,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.localRoad1114Outl,
                'line-width': {
                    'stops': roadsWidthStops.localRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road 16o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad1617Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road 12o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road',
            'minzoom': 12,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad1215Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.connectingRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road 14o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.connectingRoad14Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road 12o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'minzoom': 12,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.connectingRoad1213Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.connectingRoad11Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road 10o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'minzoom': 10,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.connectingRoad10Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 14o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.secondaryRoad14Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 12o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 12,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1213Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.secondaryRoad11Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 10o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 10,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.secondaryRoad10Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 9o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 9,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.secondaryRoad9Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 17o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 17,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorRoad17Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 16o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 16,
            'maxzoom': 17,
            'paint': {
                'line-color': nightColorMap.majorRoad16Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorRoad15Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 10o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 10,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.majorRoad1014Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 8o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 8,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.majorRoad89Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 16o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad1617Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 14o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 14,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad1415Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 11,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.internationalRoad1113Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 7o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 7,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.internationalRoad710Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway Ao',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway',
            'paint': {
                'line-color': nightColorMap.motorwayOutl,
                'line-width': {
                    'stops': roadsWidthStops.motorwayOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        { // Non toll tunnels
            'id': 'Minor local road tunnel 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road tunnel',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Minor local road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road tunnel',
            'minzoom': 0,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1114Outl,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Local road tunnel 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Local road tunnel',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.localRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.localRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Local road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Local road tunnel',
            'minzoom': 0,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.localRoad1114Outl,
                'line-width': {
                    'stops': roadsWidthStops.localRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road tunnel 16o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road tunnel',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad1617Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road tunnel',
            'minzoom': 0,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad1215Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road tunnel 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.connectingRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road tunnel 14o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.connectingRoad14Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road tunnel 12o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'minzoom': 12,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.connectingRoad1213Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road tunnel 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.connectingRoad11Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'minzoom': 0,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.connectingRoad10Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road tunnel 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road tunnel 14o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.secondaryRoad14Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road tunnel 12o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'minzoom': 12,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1213Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road tunnel 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.secondaryRoad11Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road tunnel 10o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'minzoom': 10,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.secondaryRoad10Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'minzoom': 0,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.secondaryRoad9Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road tunnel 17o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'minzoom': 17,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorRoad17Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road tunnel 16o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'minzoom': 16,
            'maxzoom': 17,
            'paint': {
                'line-color': nightColorMap.majorRoad16Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road tunnel 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorRoad15Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road tunnel 10o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'minzoom': 10,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.majorRoad1014Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'minzoom': 0,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.majorRoad89Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road tunnel 16o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'minzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad1617Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road tunnel 14o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.internationalRoad1415Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road tunnel 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'minzoom': 11,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.internationalRoad1113Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road tunnel 0o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.internationalRoad710Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Motorway tunnel Ao',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Motorway tunnel',
            'paint': {
                'line-color': nightColorMap.motorwayOutl,
                'line-width': {
                    'stops': roadsWidthStops.motorwayOutl
                },
                'line-dasharray': [1.0, 1.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        { // NON Toll roads oulines
            'id': 'Minor local road 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Minor local road 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road',
            'minzoom': 11,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1114Outl,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Local road 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Local road',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.localRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.localRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Local road 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Local road',
            'minzoom': 11,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.localRoad1114Outl,
                'line-width': {
                    'stops': roadsWidthStops.localRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road 16o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad1617Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road 12o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road',
            'minzoom': 12,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad1215Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.connectingRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road 14o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.connectingRoad14Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road 12o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'minzoom': 12,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.connectingRoad1213Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.connectingRoad11Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road 10o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'minzoom': 10,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.connectingRoad10Outl,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1517Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road 14o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.secondaryRoad14Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road 12o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'minzoom': 12,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1213Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.secondaryRoad11Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road 10o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'minzoom': 10,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.secondaryRoad10Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road 9o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'minzoom': 9,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.secondaryRoad9Outl,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road 17o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'minzoom': 17,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorRoad17Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road 16o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'minzoom': 16,
            'maxzoom': 17,
            'paint': {
                'line-color': nightColorMap.majorRoad16Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road 15o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorRoad15Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road 10o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'minzoom': 10,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.majorRoad1014Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road 8o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'minzoom': 8,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.majorRoad89Outl,
                'line-width': {
                    'stops': roadsWidthStops.majorRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road 16o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'minzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad1617Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road 14o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'minzoom': 14,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad1415Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road 11o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'minzoom': 11,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.internationalRoad1113Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road 7o',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'minzoom': 7,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.internationalRoad710Outl,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoadOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Motorway Ao',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Motorway',
            'paint': {
                'line-color': nightColorMap.motorwayOutl,
                'line-width': {
                    'stops': roadsWidthStops.motorwayOutl
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Non public road 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Non public road',
            'minzoom': 11,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.nonPublicRoad1114,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Non public road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Non public road',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.nonPublicRoad1517,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Pedestrian road',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Pedestrian road',
            'minzoom': 16,
            'paint': {
                'line-color': nightColorMap.pedestrianRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Walkway road',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Walkway road',
            'minzoom': 16,
            'paint': {
                'line-color': nightColorMap.walkwayRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Parking road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Parking road',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Parking road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Parking road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad15,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Parking road 13',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Parking road',
            'minzoom': 13,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1314,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        { // Toll roads polylines
            'id': 'Toll minor local road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll minor local road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad15,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll minor local road 13',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road',
            'minzoom': 13,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1314,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.localRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.localRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.localRoad15,
                'line-width': {
                    'stops': roadsWidthStops.localRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road 13',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road',
            'minzoom': 13,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.localRoad1314,
                'line-width': {
                    'stops': roadsWidthStops.localRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road 17',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road',
            'minzoom': 17,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad17,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road',
            'minzoom': 16,
            'maxzoom': 17,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad16,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad15,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road',
            'minzoom': 12,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad1214,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road 10',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road',
            'minzoom': 10,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad11,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.connectingRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.connectingRoad15,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.connectingRoad14,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road 13',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'minzoom': 13,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.connectingRoad13,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'minzoom': 12,
            'maxzoom': 13,
            'paint': {
                'line-color': nightColorMap.connectingRoad12,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.connectingRoad11,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.secondaryRoad15,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.secondaryRoad14,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 12,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1213,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.secondaryRoad11,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road 10',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'minzoom': 10,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.secondaryRoad10,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 17',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 17,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorRoad17,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 16,
            'maxzoom': 17,
            'paint': {
                'line-color': nightColorMap.majorRoad16,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorRoad15,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.majorRoad14,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 10',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 10,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.majorRoad1013,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 9',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 9,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.majorRoad9,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road 8',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'minzoom': 8,
            'maxzoom': 9,
            'paint': {
                'line-color': nightColorMap.majorRoad8,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad15,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.internationalRoad14,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 11,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.internationalRoad1113,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 10',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 10,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.internationalRoad10,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 9',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 9,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.internationalRoad9,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 8',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 8,
            'maxzoom': 9,
            'paint': {
                'line-color': nightColorMap.internationalRoad8,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 7',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 7,
            'maxzoom': 8,
            'paint': {
                'line-color': nightColorMap.internationalRoad7,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road 5',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'minzoom': 5,
            'maxzoom': 7,
            'paint': {
                'line-color': nightColorMap.internationalRoad56,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.motorway1517,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway',
            'minzoom': 12,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.motorway1214,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.motorway11,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway 5',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway',
            'minzoom': 5,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.motorway510,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        { // Toll road tunnels
            'id': 'Toll minor local road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road tunnel',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll minor local road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad15,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll minor local road tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road tunnel',
            'minzoom': 0,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1314,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road tunnel',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.localRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.localRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.localRoad15,
                'line-width': {
                    'stops': roadsWidthStops.localRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll local road tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road tunnel',
            'minzoom': 0,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.localRoad1314,
                'line-width': {
                    'stops': roadsWidthStops.localRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road tunnel 17',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road tunnel',
            'minzoom': 17,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad17,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road tunnel',
            'minzoom': 16,
            'maxzoom': 17,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad16,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad15,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road tunnel 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road tunnel',
            'minzoom': 12,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad1214,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major local road tunnel 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road tunnel',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad11,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.connectingRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.connectingRoad15,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road tunnel 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.connectingRoad14,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road tunnel 13',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'minzoom': 13,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.connectingRoad13,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road tunnel 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'minzoom': 12,
            'maxzoom': 13,
            'paint': {
                'line-color': nightColorMap.connectingRoad12,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll connecting road tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'minzoom': 0,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.connectingRoad11,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.secondaryRoad15,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.secondaryRoad14,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 12,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1213,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.secondaryRoad11,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll secondary road tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'minzoom': 0,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.secondaryRoad10,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 17',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 17,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorRoad17,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 16,
            'maxzoom': 17,
            'paint': {
                'line-color': nightColorMap.majorRoad16,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorRoad15,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.majorRoad14,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 10',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 10,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.majorRoad1013,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 9',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 9,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.majorRoad9,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll major road tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'minzoom': 0,
            'maxzoom': 9,
            'paint': {
                'line-color': nightColorMap.majorRoad8,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'minzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad15,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.internationalRoad14,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'minzoom': 11,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.internationalRoad1113,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 10',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'minzoom': 10,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.internationalRoad10,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 9',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'minzoom': 9,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.internationalRoad9,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 8',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'minzoom': 8,
            'maxzoom': 9,
            'paint': {
                'line-color': nightColorMap.internationalRoad8,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 7',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'minzoom': 7,
            'maxzoom': 8,
            'paint': {
                'line-color': nightColorMap.internationalRoad7,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll international road tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'maxzoom': 7,
            'paint': {
                'line-color': nightColorMap.internationalRoad56,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway tunnel',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.motorway1517,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway tunnel 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway tunnel',
            'minzoom': 12,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.motorway1214,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway tunnel 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway tunnel',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.motorway11,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Toll motorway tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway tunnel',
            'minzoom': 0,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.motorway510,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Minor local road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road tunnel',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Minor local road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad15,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Minor local road tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road tunnel',
            'minzoom': 0,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1314,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Local road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Local road tunnel',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.localRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.localRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Local road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Local road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.localRoad15,
                'line-width': {
                    'stops': roadsWidthStops.localRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Local road tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Local road tunnel',
            'minzoom': 0,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.localRoad1314,
                'line-width': {
                    'stops': roadsWidthStops.localRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road tunnel 17',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road tunnel',
            'minzoom': 17,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad17,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road tunnel',
            'minzoom': 16,
            'maxzoom': 17,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad16,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad15,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road tunnel 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road tunnel',
            'minzoom': 12,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad1214,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road tunnel 10',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road tunnel',
            'minzoom': 10,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad11,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.connectingRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.connectingRoad15,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road tunnel 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.connectingRoad14,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road tunnel 13',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'minzoom': 13,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.connectingRoad13,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road tunnel 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'minzoom': 12,
            'maxzoom': 13,
            'paint': {
                'line-color': nightColorMap.connectingRoad12,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'minzoom': 0,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.connectingRoad11,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.secondaryRoad15,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road tunnel 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.secondaryRoad14,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road tunnel 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'minzoom': 11,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1213,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road tunnel 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.secondaryRoad11,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'minzoom': 0,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.secondaryRoad10,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road tunnel 17',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'minzoom': 17,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorRoad17,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'minzoom': 16,
            'maxzoom': 17,
            'paint': {
                'line-color': nightColorMap.majorRoad16,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorRoad15,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road tunnel 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.majorRoad14,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road tunnel 10',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'minzoom': 10,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.majorRoad1013,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road tunnel 9',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'minzoom': 9,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.majorRoad9,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'minzoom': 0,
            'maxzoom': 9,
            'paint': {
                'line-color': nightColorMap.majorRoad8,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road tunnel 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'minzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad15,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road tunnel 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.internationalRoad14,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road tunnel 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'minzoom': 11,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.internationalRoad1113,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road tunnel 10',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'minzoom': 10,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.internationalRoad10,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road tunnel 9',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'minzoom': 9,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.internationalRoad9,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road tunnel 8',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'minzoom': 8,
            'maxzoom': 9,
            'paint': {
                'line-color': nightColorMap.internationalRoad8,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road tunnel 7',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'minzoom': 7,
            'maxzoom': 8,
            'paint': {
                'line-color': nightColorMap.internationalRoad7,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'maxzoom': 7,
            'paint': {
                'line-color': nightColorMap.internationalRoad56,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Motorway tunnel 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Motorway tunnel',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.motorway1517,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Motorway tunnel 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Motorway tunnel',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.motorway1214,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        { // NON Toll roads polyline
            'id': 'Minor local road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Minor local road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad15,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Minor local road 13',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road',
            'minzoom': 13,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.minorLocalRoad1314,
                'line-width': {
                    'stops': roadsWidthStops.minorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Local road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Local road',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.localRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.localRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Local road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Local road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.localRoad15,
                'line-width': {
                    'stops': roadsWidthStops.localRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Local road 13',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Local road',
            'minzoom': 13,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.localRoad1314,
                'line-width': {
                    'stops': roadsWidthStops.localRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road 17',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road',
            'minzoom': 17,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad17,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road',
            'minzoom': 16,
            'maxzoom': 17,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad16,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad15,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road',
            'minzoom': 12,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad1214,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major local road 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major local road',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.majorLocalRoad11,
                'line-width': {
                    'stops': roadsWidthStops.majorLocalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.connectingRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.connectingRoad15,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.connectingRoad14,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road 13',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'minzoom': 13,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.connectingRoad13,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'minzoom': 12,
            'maxzoom': 13,
            'paint': {
                'line-color': nightColorMap.connectingRoad12,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Connecting road 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.connectingRoad11,
                'line-width': {
                    'stops': roadsWidthStops.connectingRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'minzoom': 16,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.secondaryRoad15,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.secondaryRoad14,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'minzoom': 12,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.secondaryRoad1213,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.secondaryRoad11,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Secondary road 10',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'minzoom': 10,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.secondaryRoad10,
                'line-width': {
                    'stops': roadsWidthStops.secondaryRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road 17',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'minzoom': 17,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.majorRoad17,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'minzoom': 16,
            'maxzoom': 17,
            'paint': {
                'line-color': nightColorMap.majorRoad16,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.majorRoad15,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.majorRoad14,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road 10',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'minzoom': 10,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.majorRoad1013,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road 9',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'minzoom': 9,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.majorRoad9,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Major road 8',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'minzoom': 8,
            'maxzoom': 9,
            'paint': {
                'line-color': nightColorMap.majorRoad8,
                'line-width': {
                    'stops': roadsWidthStops.majorRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road 16',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'minzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad1617,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'minzoom': 15,
            'maxzoom': 16,
            'paint': {
                'line-color': nightColorMap.internationalRoad15,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road 14',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'minzoom': 14,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.internationalRoad14,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'minzoom': 11,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.internationalRoad1113,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road 10',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'minzoom': 10,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.internationalRoad10,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road 9',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'minzoom': 9,
            'maxzoom': 10,
            'paint': {
                'line-color': nightColorMap.internationalRoad9,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road 8',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'minzoom': 8,
            'maxzoom': 9,
            'paint': {
                'line-color': nightColorMap.internationalRoad8,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road 7',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'minzoom': 7,
            'maxzoom': 8,
            'paint': {
                'line-color': nightColorMap.internationalRoad7,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'International road 5',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'minzoom': 5,
            'maxzoom': 7,
            'paint': {
                'line-color': nightColorMap.internationalRoad56,
                'line-width': {
                    'stops': roadsWidthStops.internationalRoad
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Motorway 15',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Motorway',
            'minzoom': 15,
            'maxzoom': 20,
            'paint': {
                'line-color': nightColorMap.motorway1517,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Motorway 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Motorway',
            'minzoom': 12,
            'maxzoom': 15,
            'paint': {
                'line-color': nightColorMap.motorway1214,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Motorway tunnel 12',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Motorway tunnel',
            'minzoom': 12,
            'maxzoom': 14,
            'paint': {
                'line-color': nightColorMap.motorway1214,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Motorway 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Motorway',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.motorway11,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Motorway tunnel 11',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Motorway tunnel',
            'minzoom': 11,
            'maxzoom': 12,
            'paint': {
                'line-color': nightColorMap.motorway11,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Motorway 5',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Motorway',
            'minzoom': 5,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.motorway510,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Motorway tunnel 0',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Motorway tunnel',
            'minzoom': 0,
            'maxzoom': 11,
            'paint': {
                'line-color': nightColorMap.motorway510,
                'line-width': {
                    'stops': roadsWidthStops.motorway
                }
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        { // Cartographic
            'id': 'Ferry road',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Ferry road',
            'paint': {
                'line-color': nightColorMap.ferryStrokeColor,
                'line-width': {
                    'stops': roadsWidthStops.ferry
                },
                'line-dasharray': [4.0, 4.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'State border',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'State border',
            'paint': {
                'line-color': nightColorMap.stateBorder,
                'line-width': {
                    'stops': roadsWidthStops.cartographicState
                },
                'line-dasharray': [5.0, 10.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Country border',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Country border',
            'paint': {
                'line-color': nightColorMap.countryBorder,
                'line-width': {
                    'stops': roadsWidthStops.cartographicCountry
                },
                'line-dasharray': [3.0, 5.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        },
        {
            'id': 'Disputed country border',
            'type': 'line',
            'source': 'vectorTiles',
            'source-layer': 'Disputed country border',
            'paint': {
                'line-color': nightColorMap.disputedCountryBorder,
                'line-width': {
                    'stops': roadsWidthStops.cartographicCountry
                },
                'line-dasharray': [3.0, 5.0]
            },
            'layout': {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 1.05
            }
        }
    ];
    // Non toll road icons
    var nightLabels = [
        {
            'id': 'Service road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Service road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Pedestrian road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Pedestrian road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Minor local road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Local road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Local road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Major local road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Major local road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Connecting road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Secondary road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Major road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'International road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Motorway icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Motorway',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        { // Non toll tunnels
            'id': 'Minor local road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Local road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Local road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Major local road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Major local road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Connecting road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Secondary road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Major road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'International road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Motorway tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Motorway tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        { // Toll roads icons
            'id': 'Toll minor local road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll local road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll major local road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll connecting road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll secondary road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll major road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll international road icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll motorway icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        { // Toll road tunnels icons
            'id': 'Toll minor local road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll local road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll major local road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll connecting road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll secondary road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll major road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll international road tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll motorway tunnel icon1',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway tunnel',
            'filter': ['<=', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.firstIconText,
                'text-halo-color': nightColorMap.firstIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        { // Second set of icons, those with black text // Non toll road icons
            'id': 'Service road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Service road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Pedestrian road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Pedestrian road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Minor local road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Local road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Local road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Major local road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Major local road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Connecting road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Secondary road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Major road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'International road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Motorway icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Motorway',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        { // Non toll tunnels
            'id': 'Minor local road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Local road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Local road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Major local road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Major local road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Connecting road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Secondary road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Major road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'International road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Motorway tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Motorway tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        { // Toll roads icons
            'id': 'Toll minor local road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll local road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll major local road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll connecting road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll secondary road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll major road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll international road icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll motorway icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        { // Toll road tunnels icons
            'id': 'Toll minor local road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll local road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll major local road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll connecting road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll secondary road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll major road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll international road tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        {
            'id': 'Toll motorway tunnel icon2',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway tunnel',
            'filter': ['>', 'icon', iconRange],
            'paint': {
                'text-color': nightColorMap.secondIconText,
                'text-halo-color': nightColorMap.secondIconTextHalo,
                'text-halo-width': 0
            },
            'layout': {
                'symbol-placement': 'line',
                'icon-rotation-alignment': 'viewport',
                'text-rotation-alignment': 'viewport',
                'text-field': '{icon_text}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-allow-overlap': false,
                'text-size': {
                    'stops': labelTextStops.icon
                },
                'icon-padding': padding.icon,
                'symbol-avoid-edges': true,
                'icon-allow-overlap': false,
                'icon-image': '{icon}'
            }
        },
        { // Non toll road labels
            'id': 'Non public road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Non public road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.minorLocalRoad
                }
            }
        },
        {
            'id': 'Walkway road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Walkway road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.minorLocalRoad
                }
            }
        },
        {
            'id': 'Parking road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Parking road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.minorLocalRoad
                }
            }
        },
        {
            'id': 'Service road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Service road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.minorLocalRoad
                }
            }
        },
        {
            'id': 'Pedestrian road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'minzoom': 16,
            'source-layer': 'Pedestrian road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.localRoad
                }
            }
        },
        {
            'id': 'Minor local road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.minorLocalRoad
                }
            }
        },
        {
            'id': 'Ferry road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Ferry road',
            'paint': {
                'text-color': nightColorMap.ferryLabelText,
                'text-halo-color': nightColorMap.ferryLabelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.ferry
                }
            }
        },
        {
            'id': 'Local road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Local road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.localRoad
                }
            }
        },
        {
            'id': 'Major local road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Major local road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.majorLocalRoad
                }
            }
        },
        {
            'id': 'Connecting road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.connectingRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.connectingRoad
                }
            }
        },
        {
            'id': 'Secondary road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.secondaryRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.secondaryRoad
                }
            }
        },
        {
            'id': 'Major road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Major road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.majorRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.majorRoad
                }
            }
        },
        {
            'id': 'International road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'International road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.internationalRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.internationalRoad
                }
            }
        },
        {
            'id': 'Motorway label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Motorway',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.motorway
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.motorway
                }
            }
        },
        { // Non toll tunnels
            'id': 'Minor local road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Minor local road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.minorLocalRoad
                }
            }
        },
        {
            'id': 'Local road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Local road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.localRoad
                }
            }
        },
        {
            'id': 'Major local road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Major local road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.majorLocalRoad
                }
            }
        },
        {
            'id': 'Connecting road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Connecting road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.connectingRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.connectingRoad
                }
            }
        },
        {
            'id': 'Secondary road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Secondary road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.secondaryRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.secondaryRoad
                }
            }
        },
        {
            'id': 'Major road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Major road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.majorRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.majorRoad
                }
            }
        },
        {
            'id': 'International road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'International road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.internationalRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.internationalRoad
                }
            }
        },
        {
            'id': 'Motorway tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Motorway tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.motorway
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.motorway
                }
            }
        },
        { // Toll roads labels
            'id': 'Toll minor local road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.minorLocalRoad
                }
            }
        },
        {
            'id': 'Toll local road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.localRoad
                }
            }
        },
        {
            'id': 'Toll major local road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.majorLocalRoad
                }
            }
        },
        {
            'id': 'Toll connecting road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.connectingRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.connectingRoad
                }
            }
        },
        {
            'id': 'Toll secondary road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.secondaryRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.secondaryRoad
                }
            }
        },
        {
            'id': 'Toll major road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.majorRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.majorRoad
                }
            }
        },
        {
            'id': 'Toll international road label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.internationalRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.internationalRoad
                }
            }
        },
        {
            'id': 'Toll motorway label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.motorway
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.motorway
                }
            }
        },
        { // Toll road tunnels labels
            'id': 'Toll minor local road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll minor local road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.minorLocalRoad
                }
            }
        },
        {
            'id': 'Toll local road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll local road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.localRoad
                }
            }
        },
        {
            'id': 'Toll major local road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll major local road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.majorLocalRoad
                }
            }
        },
        {
            'id': 'Toll connecting road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll connecting road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.connectingRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.connectingRoad
                }
            }
        },
        {
            'id': 'Toll secondary road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll secondary road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.secondaryRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.secondaryRoad
                }
            }
        },
        {
            'id': 'Toll major road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll major road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.majorRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.majorRoad
                }
            }
        },
        {
            'id': 'Toll international road tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll international road tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.internationalRoad
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.internationalRoad
                }
            }
        },
        {
            'id': 'Toll motorway tunnel label',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Toll motorway tunnel',
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.motorway
                }
            },
            'layout': {
                'symbol-placement': 'line',
                'text-field': '{name}',
                'text-rotation-alignment': 'map',
                'text-keep-upright': true,
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.motorway
                }
            }
        },
        {
            'id': 'Ocean name',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Ocean name',
            'filter': ['!=', 'name', ' '],
            'paint': {
                'text-color': nightColorMap.oceanLabelText,
                'text-halo-color': nightColorMap.oceanLabelHalo,
                'text-halo-width': 2
            },
            'layout': {
                'symbol-placement': 'point',
                'text-field': '{name}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.ocean
                }
            }
        },
        {
            'id': 'National park name',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'National park name',
            'filter': ['!=', 'name', ' '],
            'paint': {
                'text-color': nightColorMap.nationalParksLabelText,
                'text-halo-color': nightColorMap.nationalParksLabelHalo,
                'text-halo-width': {
                    'stops': labelTextHalo.nationalPark
                }
            },
            'layout': {
                'symbol-placement': 'point',
                'text-field': '{name}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.park
                }
            }
        },
        {
            'id': 'Railway station',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Railway station',
            'filter': ['!=', 'name', ' '],
            'paint': {
                'text-color': nightColorMap.labelText,
                'text-halo-color': nightColorMap.labelTextHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'point',
                'text-field': '{name}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.rail
                }
            }
        },
        {
            'id': 'Airport POI',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Airport POI',
            'filter': ['!=', 'name', ' '],
            'paint': {
                'text-color': nightColorMap.airportLabelText,
                'text-halo-color': nightColorMap.airportLabelHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'point',
                'text-field': '{name}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.airport
                }
            }
        },
        {
            'id': 'Village',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Village',
            'filter': ['!=', 'name', ' '],
            'paint': {
                'text-color': nightColorMap.cityLabelText,
                'text-halo-color': nightColorMap.cityLabelHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'point',
                'text-field': '{name}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-padding': padding.village,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.village
                }
            }
        },
        {
            'id': 'Town',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Town',
            'filter': ['!=', 'name', ' '],
            'paint': {
                'text-color': nightColorMap.cityLabelText,
                'text-halo-color': nightColorMap.cityLabelHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'point',
                'text-field': '{name}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-padding': padding.town,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.town
                }
            }
        },
        {
            'id': 'Small city',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Small city',
            'filter': ['!=', 'name', ' '],
            'paint': {
                'text-color': nightColorMap.cityLabelText,
                'text-halo-color': nightColorMap.cityLabelHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'point',
                'text-field': '{name}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-padding': padding.smallCity,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.smallCity
                }
            }
        },
        {
            'id': 'Medium city',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Medium city',
            'filter': ['!=', 'name', ' '],
            'paint': {
                'text-color': nightColorMap.cityLabelText,
                'text-halo-color': nightColorMap.cityLabelHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'point',
                'text-field': '{name}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-padding': padding.mediumCity,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.mediumCity
                }
            }
        },
        {
            'id': 'Large city',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Large city',
            'filter': ['!=', 'name', ' '],
            'paint': {
                'text-color': nightColorMap.cityLabelText,
                'text-halo-color': nightColorMap.cityLabelHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'point',
                'text-field': '{name}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-padding': padding.largeCity,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.largeCity
                }
            }
        },
        {
            'id': 'Capital city',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Capital city',
            'filter': ['!=', 'name', ' '],
            'paint': {
                'text-color': nightColorMap.cityLabelText,
                'text-halo-color': nightColorMap.cityLabelHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'point',
                'text-field': '{name}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-padding': padding.capitalCity,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.capitalCity
                }
            }
        },
        {
            'id': 'State name short',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'State name short',
            'filter': ['!=', 'name', ' '],
            'paint': {
                'text-color': nightColorMap.stateLabelText,
                'text-halo-color': nightColorMap.stateLabelHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'point',
                'text-field': '{name}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-padding': padding.state,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.state
                }
            }
        },
        {
            'id': 'State name',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'State name',
            'filter': ['!=', 'name', ' '],
            'paint': {
                'text-color': nightColorMap.stateLabelText,
                'text-halo-color': nightColorMap.stateLabelHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'point',
                'text-field': '{name}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-padding': padding.state,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.state
                }
            }
        },
        {
            'id': 'Country name',
            'type': 'symbol',
            'source': 'vectorTiles',
            'source-layer': 'Country name',
            'filter': ['!=', 'name', ' '],
            'paint': {
                'text-color': nightColorMap.countryLabelText,
                'text-halo-color': nightColorMap.countryLabelHalo,
                'text-halo-width': 1
            },
            'layout': {
                'symbol-placement': 'point',
                'text-field': '{name}',
                'text-font': fonts.regular,
                'text-offset': textOffset,
                'text-padding': padding.country,
                'text-letter-spacing': 0.1,
                'text-size': {
                    'stops': labelTextStops.country
                }
            }
        }
    ];

    return {
        basic: [].concat(nightBackgroundLayer, nightLanduse, nightWater, nightRoads, nightLabels),
        labels: [].concat(nightLabels),
        hybrid: [].concat(nightRoads, nightLabels)
    }
});

